import React from "react";

import { selectCurrentStage } from "@/store/slices/stages.slice";
import { useAppSelector } from "@/hooks/common";

import { TextInputView } from "./text.input.view";
import { SelectPersonView } from "./select.person.view";
import { MapView } from "./map.view";
import { DateSelectView } from "./date.select.view";

export const StageView = () => {
  const currentStage = useAppSelector(selectCurrentStage)!;

  if (currentStage.answer_type === "text_input") {
    return <TextInputView />;
  }

  if (currentStage.answer_type === "select_person") {
    return <SelectPersonView />;
  }

  if (currentStage.answer_type === "map") {
    return <MapView />;
  }

  if (currentStage.answer_type === "date_input") {
    return <DateSelectView />;
  }

  return <>Invalid Stage</>;
};
